import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getByIdLottery = (params) => {
    return axios.get(`${backendHost}/api/admin/lottery/edit`, {params});
};

export {
    getByIdLottery
}